export default __webpack_public_path__ + "static/media/finder_list_disable.4d997cdd.svg";